import React from "react";
import { RouteComponentProps } from "@reach/router";
import AppPage from "../../components/AppFrame/AppPage";
import { useAppSelector } from "../../hooks/redux";
import { Divider, Stack } from "@mui/material";
import Filters from "./Filters";
import Gallery from "./Gallery";



const ExplorePage: React.FC<RouteComponentProps> = () => {

  const stats = useAppSelector(state => state.stats);
  const traits = useAppSelector(state => state.traits);
  const nfts = useAppSelector(state => state.nfts);

  const loading = stats.loading || traits.loading || nfts.loading;

  return (
    <AppPage loading={loading}>
      <Stack direction="row" spacing={2} sx={{ flex: 1 }}>
        <Filters />
        <Divider orientation="vertical" flexItem />
        <Gallery />
      </Stack>
    </AppPage>
  );
};

export default ExplorePage;